import { render, staticRenderFns } from "./appTable.vue?vue&type=template&id=6fc238a4&scoped=true&"
import script from "./appTable.vue?vue&type=script&lang=js&"
export * from "./appTable.vue?vue&type=script&lang=js&"
import style0 from "./appTable.vue?vue&type=style&index=0&id=6fc238a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc238a4",
  null
  
)

component.options.__file = "appTable.vue"
export default component.exports